// Person-oriented name: prefer contact first/last over SF-computed `name`
// (which can lag Heroku Connect). Falls back to contact.name, then account.name.
// For account-level display (business company vs person), use displayNameForAccount.
function displayMemberName(contact, account) {
  if (!contact && !account) return

  const firstName = contact?.firstName || contact?.firstname
  const lastName = contact?.lastName || contact?.lastname
  const fromParts = [firstName, lastName].filter(Boolean).join(' ')

  return fromParts || contact?.name || account?.name
}

export default displayMemberName
